import styled, { css } from 'styled-components';

const STATUS_BORDER_COLOR = {
  success: 'var(--color-accent-primary-strong)',
  warning: 'var(--color-warning-strong)',
  error: 'var(--color-error-strong)',
  info: 'var(--color-info-strong)'
};

const STATUS_BACKGROUND_COLOR = {
  success: 'var(--color-accent-primary-weakest)',
  warning: 'var(--color-warning-weakest)',
  error: 'var(--color-error-weakest)',
  info: 'var(--color-components-modal-body-bg)'
};

const Notification = styled.div`
  border-radius: var(--size-border-radius-md);
  display: flex;
  gap: 8px;
  padding: 8px;
  text-align: left;
  width: ${({ $size }) => $size || '100%'};

  ${({ $status }) => css`
    background-color: ${STATUS_BACKGROUND_COLOR[$status]};
    border: 1px solid ${STATUS_BORDER_COLOR[$status]};
    border-left-width: 0.4rem;
  `}
`;

const NotificationBody = styled.div`
  flex-grow: 1;
  padding-top: 1px;
`;

export { Notification, NotificationBody };
